export default function ContactUsPage() {
    return (<div>
        Sample Page
    </div>)
}